import { render, staticRenderFns } from "./NotificationToolbar.vue?vue&type=template&id=c89ab732"
import script from "./NotificationToolbar.vue?vue&type=script&lang=js"
export * from "./NotificationToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports